import { FocaltecBillings, FocaltecBillingsQueryParams } from "../model/FocaltecBilling";
import { callAPI, HTTPMethod } from "./API"

const getBaseApi = () => {
    return `/internal/focaltec/billing`
}

export async function getFocaltecBillings(params: FocaltecBillingsQueryParams, page: number, offset: number) : Promise<FocaltecBillings> {
    return await callAPI(getBaseApi(), {
        method: HTTPMethod.GET,
        query: {
            tenantId: params.tenantId,
            startDate: params.startDate,
            endDate: params.endDate,
            pageSize: page.toString(),
            offset: offset.toString()
        }
    });
}